// v3.11.0 — Espace Pro : demandes clients routées par le moteur de leads.
// Poll GET /api/v3/me/pro/leads toutes les 20s ; "Marquer traité" par lead.

import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL || "";

const URGENCY_STYLE = {
  faible: { color: "#34D399", bg: "rgba(52,211,153,0.12)" },
  moyenne: { color: "#FBBF24", bg: "rgba(251,191,36,0.12)" },
  urgente: { color: "#F87171", bg: "rgba(248,113,113,0.15)" },
};

export default function ProLeadsSection() {
  const [leads, setLeads] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const fetchLeads = async () => {
    try {
      const token = localStorage.getItem("civ_user_token");
      if (!token) return;
      const r = await fetch(`${API}/api/v3/me/pro/leads`, { headers: { Authorization: `Bearer ${token}` } });
      const d = await r.json().catch(() => ({}));
      if (r.ok && d.ok) setLeads(d.leads || []);
    } catch (_) { /* silencieux */ }
    setLoaded(true);
  };

  useEffect(() => {
    fetchLeads();
    const iv = setInterval(fetchLeads, 20000);
    return () => clearInterval(iv);
  }, []);

  const markHandled = async (leadId) => {
    try {
      const token = localStorage.getItem("civ_user_token");
      await fetch(`${API}/api/v3/me/pro/leads/${leadId}/handle`, {
        method: "POST", headers: { Authorization: `Bearer ${token}` },
      });
      setLeads((prev) => prev.map((l) => (l.lead_id === leadId ? { ...l, status: "handled" } : l)));
    } catch (_) { /* silencieux */ }
  };

  const newCount = leads.filter((l) => l.status === "new").length;

  return (
    <div data-testid="pro-leads-section">
      {!loaded ? (
        <div style={{ fontSize: 12, color: "rgba(244,241,232,0.5)" }}>Chargement des demandes…</div>
      ) : leads.length === 0 ? (
        <div data-testid="pro-leads-empty" style={{ fontSize: 12.5, color: "rgba(244,241,232,0.55)", padding: "6px 0" }}>
          Aucune demande client pour l'instant. Dès qu'un client décrit un besoin dans le chat AYA correspondant à ton métier, elle apparaît ici.
        </div>
      ) : (
        <>
          {newCount > 0 && (
            <div style={{ fontSize: 11.5, color: "#34D399", fontWeight: 700, marginBottom: 8 }}>
              {newCount} nouvelle{newCount > 1 ? "s" : ""} demande{newCount > 1 ? "s" : ""} à traiter
            </div>
          )}
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {leads.map((l, i) => {
              const us = URGENCY_STYLE[l.urgency] || URGENCY_STYLE.moyenne;
              const handled = l.status === "handled";
              return (
                <div
                  key={l.lead_id}
                  data-testid={`pro-lead-item-${i}`}
                  style={{
                    borderRadius: 12, padding: "12px 14px",
                    background: handled ? "rgba(255,255,255,0.03)" : "rgba(16,185,129,0.06)",
                    border: `1px solid ${handled ? "rgba(255,255,255,0.08)" : "rgba(16,185,129,0.3)"}`,
                    opacity: handled ? 0.6 : 1,
                  }}
                >
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                    <span style={{
                      fontSize: 10.5, fontWeight: 800, padding: "3px 9px", borderRadius: 999,
                      color: us.color, background: us.bg,
                    }}>{l.urgency_label}</span>
                    <span style={{ fontSize: 10.5, color: "rgba(244,241,232,0.45)" }}>
                      {l.category_label || l.domain} · {new Date(l.created_at).toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })}
                    </span>
                  </div>
                  <div style={{ fontSize: 13, color: "#F4F1E8", marginTop: 8, lineHeight: 1.45 }}>
                    "{l.summary_clean}"
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 10, gap: 8 }}>
                    <span style={{ fontSize: 11, color: "rgba(244,241,232,0.5)" }}>
                      {l.client_name || "Client AYA"}{l.client_phone ? ` · ${l.client_phone}` : ""}
                    </span>
                    {!handled ? (
                      <button
                        type="button"
                        data-testid={`pro-lead-handle-${i}`}
                        onClick={() => markHandled(l.lead_id)}
                        style={{
                          fontSize: 11.5, fontWeight: 700, borderRadius: 999, padding: "6px 14px", cursor: "pointer",
                          background: "linear-gradient(135deg,#34D399,#10B981)", color: "#062A1F", border: "none",
                        }}
                      >✓ Marquer traité</button>
                    ) : (
                      <span style={{ fontSize: 11, color: "#34D399" }}>✓ Traitée</span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}
